import React, { useState, useEffect } from "react"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import "./blockTideTimes.scss"
import axios from "axios"
import { Link } from "gatsby"
import { makeStyles, } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      color: "#b60011",   
    }
  },
}));

const TideTimesData = props => {
  const changetoTwentyFourHourTime = i => {
    if (i < 10) {
      i = "0" + i
    }
    return i
  }

  var today = new Date(props.Date)
  var todaycheck = new Date()
  todaycheck.setHours(0, 0, 0, 0)
  var timeNow = new Date()

  var h = changetoTwentyFourHourTime(timeNow.getHours())
  var m = changetoTwentyFourHourTime(timeNow.getMinutes())
  var filteredNow = h + ":" + m

  var timeArray = []
  timeArray.push(filteredNow)

  var ifNextTimeEntry
  if (
    today.getDate() === todaycheck.getDate() &&
    today.getMonth() === todaycheck.getMonth()
  ) {
    for (var i = 0; i < props.TideTimes.length; i++) {
      timeArray.push(props.TideTimes[i].Time)

      timeArray.sort()
      var nextTime = timeArray.indexOf(filteredNow) + 1

      if (nextTime < 5) {
        if (typeof(props.TideTimes[`${nextTime - 1}`]) !== 'undefined' && props.TideTimes[`${nextTime - 1}`] != null) {
          ifNextTimeEntry = props.TideTimes[`${nextTime - 1}`].Time
        }
      } else if (nextTime === 5) {
        if (typeof(props.TideTimes[3]) !== 'undefined' && props.TideTimes[3] != null) {
          ifNextTimeEntry = props.TideTimes[3].Time
        }
      }
    }
  }
  return props.TideTimes.map((result, index) =>
  props.mode === "desktop" ? (
      <TideTimesRowDesktop
        today={ifNextTimeEntry}
        date={props.formattedDate}
        TidesLowHigh={result.highLow}
        currentTime={result.Time}
        TidesTime={result.Time}
        TidesHeight={result.Height + "m"}
        key={index}
        index={index}
      />
    ) : (
      <TideTimesRowMobile
        today={ifNextTimeEntry}
        date={props.formattedDate}
        TidesLowHigh={result.highLow}
        currentTime={result.Time}
        TidesTime={result.Time}
        TidesHeight={result.Height + "m"}
        key={index}
        index={index}
      />
    )
  )
}


const TideTimesRowDesktop = props => {
  return props.today === props.currentTime ? (
    props.index === 0 ? (
      <tr className="borderTop">
        <td className="boldText">
          <span style={{ color: "#b60011" }}>{props.date}</span>
        </td>
        <td>
          <span style={{ color: "#b60011" }}>{props.TidesLowHigh}</span>
        </td>
        <td>
          <span style={{ color: "#b60011" }}>{props.TidesTime}</span>
        </td>
        <td>
          <span style={{ color: "#b60011" }}>{props.TidesHeight}</span>
        </td>
      </tr>
    ) : (
      <tr>
        <td className="boldText"></td>
        <td>
          <span style={{ color: "#b60011" }}>{props.TidesLowHigh}</span>
        </td>
        <td>
          <span style={{ color: "#b60011" }}>{props.TidesTime}</span>
        </td>
        <td>
          <span style={{ color: "#b60011" }}>{props.TidesHeight}</span>
        </td>
      </tr>
    )
  ) : props.index === 0 ? (
    <tr className="borderTop">
      <td className="boldText">{props.date}</td>
      <td>{props.TidesLowHigh}</td>
      <td>{props.TidesTime}</td>
      <td>{props.TidesHeight}</td>
    </tr>
  ) : (
    <tr>
      <td className="boldText"></td>
      <td>{props.TidesLowHigh}</td>
      <td>{props.TidesTime}</td>
      <td>{props.TidesHeight}</td>
    </tr>
  )
}

const TideTimesRowMobile = props => {
  return props.today === props.currentTime ? (
    props.index === 0 ? (
      <>
        <tr className="borderTop">
          <th colSpan="3" className="boldText">
            <span style={{ color: "#b60011" }}>{props.date}</span>
          </th>
        </tr>
        <tr>
          <td>
            <span style={{ color: "#b60011" }}>{props.TidesLowHigh}</span>
          </td>
          <td>
            <span style={{ color: "#b60011" }}>{props.TidesTime}</span>
          </td>
          <td style={{ textAlign: "right" }}>
            <span style={{ color: "#b60011" }}>{props.TidesHeight}</span>
          </td>
        </tr>
      </>
    ) : (
      <tr>
        <td>
          <span style={{ color: "#b60011" }}>{props.TidesLowHigh}</span>
        </td>
        <td>
          <span style={{ color: "#b60011" }}>{props.TidesTime}</span>
        </td>
        <td style={{ textAlign: "right" }}>
          <span style={{ color: "#b60011" }}>{props.TidesHeight}</span>
        </td>
      </tr>
    )
  ) : props.index === 0 ? (
    <>
      <tr className="borderBottom">
        <th colSpan="3" className="boldText">
          {props.date}
        </th>
      </tr>
      <tr>
        <td>{props.TidesLowHigh}</td>
        <td>{props.TidesTime}</td>
        <td style={{ textAlign: "right" }}>{props.TidesHeight}</td>
      </tr>
    </>
  ) : (
    <tr>
      <td>{props.TidesLowHigh}</td>
      <td>{props.TidesTime}</td>
      <td style={{ textAlign: "right" }}>{props.TidesHeight}</td>
    </tr>
  )
}

// const TideTimesItem = props => {
//     return (
//         props.today === props.currentTime ? <span style={{color:'#b60011'}}>{props.value}<br /></span> : <span >{props.value}<br /></span>
//     )
// }

// const HighWater = props => {
//     return (
//         props.today === props.currentTime ? <span style={{color:'#b60011'}}>{props.value}<br /></span> : <span>{props.value}<br /></span>
//     )
// }

const BlockTideTimes = props => {
  const mobileVP = useMediaQuery("(max-width:1420px)")
  const [data, setData] = useState([])
  const hoverStyle = useStyles();

  useEffect(() => {
    const fetchData = async () => {
      //setIsError(false)
      //setIsLoading(true)
      try {
        if (props.title === 'Jersey weather') {
          const result = await axios(process.env.MET_JSYHOMEPAGETIDETIMES)
          setData(result.data)
        } else {
          const result = await axios(process.env.MET_GSYHOMEPAGETIDETIMES)
          setData(result.data)
        }
        //console.log(result.data);
      } catch (error) {
        //setIsError(true);
        console.log(error)
      }
      //setIsLoading(false)
    }
    fetchData()
  }, []) // eslint-disable-line

  return (
    <React.Fragment>
      <h2>
        {props.title === 'Jersey weather' && <Link className={hoverStyle.root} style={{fontSize:"18px", fontWeight:"600"}} to="/tidetimes">Tide times St Helier</Link>}
        {props.title === 'Guernsey weather' && <Link className={hoverStyle.root} style={{fontSize:"18px", fontWeight:"600"}} to="/tidetimes-guernsey">Tide times St Peter Port</Link>}
      </h2>
      {!mobileVP ? (
        <Link style={{ color: 'inherit', textDecoration: 'inherit'}} to={props.title === "Jersey weather" ? "/tidetimes" : "/tidetimes-guernsey"}>
        <table className="tide-desktop">
          <tbody>
          { (typeof(data[0]) !== 'undefined' && data[0] != null) && <TideTimesData key={0} {...data[0]} mode={"desktop"} /> }
          { (typeof(data[1]) !== 'undefined' && data[1] != null) && <TideTimesData key={1} {...data[1]} mode={"desktop"} /> }
          { (typeof(data[2]) !== 'undefined' && data[2] != null) && <TideTimesData key={2} {...data[2]} mode={"desktop"} /> }
          { (typeof(data[3]) !== 'undefined' && data[3] != null) && <TideTimesData key={3} {...data[3]} mode={"desktop"} /> }

            {/* {data.map((result, index) => (
              <TideTimesData key={index} {...result} mode={"desktop"} />
            ))} */}
          </tbody>
        </table>
        </Link>
      ) : (
        <>
        <Link style={{ color: 'inherit', textDecoration: 'inherit'}} to={props.title === "Jersey weather" ? "/tidetimes" : "/tidetimes-guernsey"}>
        <table className="tide-mobile">
          <tbody>
            {/* {data.map((result, index) => ( */}
              { (typeof(data[0]) !== 'undefined' && data[0] != null) && <TideTimesData key={0} {...data[0]} mode={"mobile"} /> }
              </tbody>
        </table>
              <br />
              <table className="tide-mobile">
              <tbody>
  
              { (typeof(data[1]) !== 'undefined' && data[1] != null) && <TideTimesData key={1} {...data[1]} mode={"mobile"} /> }
            {/* ))} */}
          </tbody>        
        </table>
        </Link>
        </>
      )}      
    </React.Fragment>
  )
}

export default BlockTideTimes
